import { refreshCartItemsSections, updateCartBubbles } from './quick-add-cart.js';

function formatSearchDrawerMoney(cents) {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents);
  }
  return '$' + (Number(cents) / 100).toFixed(2);
}

function onSearchDrawerVariantChange(selectElement) {
  const selectedOption = selectElement.options[selectElement.selectedIndex];
  const form = selectElement.closest('form');
  const addButton = form?.querySelector('.btn-atc');
  const productItem = selectElement.closest('.product-item');
  const variantAvailable = selectedOption.getAttribute('data-available') === 'true';

  if (addButton) {
    addButton.disabled = !variantAvailable;
    addButton.textContent = variantAvailable ? (addButton.dataset.textAddToCart || 'Add') : 'Sold out';
  }

  const priceContainer = productItem?.querySelector('.product-item-price');
  const variantPrice = selectedOption.getAttribute('data-price');
  const variantComparePrice = selectedOption.getAttribute('data-compare-at-price');
  const compValueLabel = 'Comp. value';

  if (priceContainer && variantPrice) {
    if (parseInt(variantComparePrice, 10) > parseInt(variantPrice, 10)) {
      priceContainer.innerHTML =
        '<span class="product-item-price-final"><span class="visually-hidden">Sale price</span><span class="money">' +
        formatSearchDrawerMoney(variantPrice) +
        '</span></span><span class="product-item-price-comp-value text-muted ms-1"><span class="money">' +
        formatSearchDrawerMoney(variantComparePrice) +
        '</span> ' +
        compValueLabel +
        '</span>';
    } else {
      priceContainer.innerHTML =
        '<span class="product-item-price-final"><span class="visually-hidden">Sale price</span><span class="money">' +
        formatSearchDrawerMoney(variantPrice) +
        '</span></span>';
    }
  }

  const variantImageSrc = selectedOption.getAttribute('data-variant-image');
  const productImage = productItem?.querySelector('.product-item-img');
  if (variantImageSrc && productImage) {
    productImage.src = variantImageSrc;
  }
}

async function handleSearchDrawerSubmit(form) {
  const btn = form.querySelector('.btn-atc');
  const select = form.querySelector('.search-drawer-variant-select');
  const hiddenId = form.querySelector('input[name="id"]');
  const variantId = select ? Number(select.value) : Number(hiddenId?.value);
  if (!variantId || btn?.disabled) return;

  btn.classList.add('loading');
  btn.disabled = true;

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
    if (!res.ok) throw new Error('Add failed');

    const cart = await fetch('/cart.js').then((r) => r.json());
    updateCartBubbles(cart.item_count);
    await refreshCartItemsSections();

    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
  } catch (err) {
    console.error('Search drawer add error:', err);
  } finally {
    btn.classList.remove('loading');
    if (select instanceof HTMLSelectElement) {
      onSearchDrawerVariantChange(select);
    } else if (btn) {
      btn.disabled = false;
    }
  }
}

document.addEventListener('change', (e) => {
  const select = e.target.closest?.('.search-drawer-variant-select');
  if (!(select instanceof HTMLSelectElement)) return;
  onSearchDrawerVariantChange(select);
});

document.addEventListener('submit', (e) => {
  const form = e.target.closest?.('.search-drawer-form');
  if (!(form instanceof HTMLFormElement)) return;
  e.preventDefault();
  handleSearchDrawerSubmit(form);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.search-drawer-variant-select').forEach((select) => {
    if (select instanceof HTMLSelectElement) {
      onSearchDrawerVariantChange(select);
    }
  });
});
